import { Fragment, type ReactNode } from "react";

import {
  splitDisclosureReferenceTokens,
  useDisclosureFootnotes,
} from "./disclosureFootnotes";

export function renderTextWithLineBreaks(text: string): ReactNode[] {
  return text.split(/\r\n|\r|\n/).map((line, index) => (
    <Fragment key={index}>
      {index > 0 ? <br /> : null}
      <TextWithDisclosureFootnotes text={line} />
    </Fragment>
  ));
}

function TextWithDisclosureFootnotes({ text }: { text: string }) {
  const { byKey } = useDisclosureFootnotes();
  return (
    <>
      {splitDisclosureReferenceTokens(text).map((part, index) => {
        if (!part.key) {
          return <Fragment key={index}>{part.text}</Fragment>;
        }
        const footnote = byKey.get(part.key);
        if (!footnote) {
          return <Fragment key={index}>{part.text}</Fragment>;
        }
        return (
          <a
            key={index}
            className="cms-disclosure-footnote-ref"
            href={`#${footnote.targetId}`}
            aria-label={`Disclosure footnote ${footnote.number}: ${footnote.label ?? footnote.key}`}
          >
            <sup>{footnote.number}</sup>
          </a>
        );
      })}
    </>
  );
}
